import { ComponentType } from 'react';
import FetchApiData from './FetchApiData';

function withApiData<T>(Component: ComponentType<T>) {
  return function HOC(props: T) {
    FetchApiData();
    return <Component {...props} />;
  };
}

export default withApiData;
